import cx from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

import * as styles from './Breadcrumbs.module.css';

const Breadcrumbs = ({
	pagePath,
	className = '',
}: {
	pagePath: string;
	className?: string;
}) => {
	const crumbs = pagePath.split('/').filter((item) => item !== '');

	return crumbs?.length > 0 ? (
		<div className={cx(styles.breadcrumbs, className)}>
			<ol className={styles.list}>
				{crumbs.map((pathSection, key) => {
					const localCrumbs = crumbs.map((item) => item);
					const label = pathSection.replace(/-/g, ' ');
					const currentPathNum = crumbs.indexOf(pathSection) + 1;
					const link = '/' + localCrumbs.splice(0, currentPathNum).join('/');

					return (
						<li className={styles.item} key={key}>
							<Link to={link} className={styles.link}>
								{label}
							</Link>
							{key + 1 !== crumbs.length && <span>/</span>}
						</li>
					);
				})}
			</ol>
		</div>
	) : null;
};

export default Breadcrumbs;
